// State Import
import { useReturnOrderPendingList } from "../../state/returnOrderPendingListState";
import { useUrlFilterState } from "../../hooks/useUrlFilterState";

// Component imports
import { GenericListHeader } from "../../components/GenericHeader";
import { ReturnTableFilterBar } from "./PendingReturnTableFilterBar";
import { ReturnTable } from "./PendingReturnTable";

export function ReturnOrderPendingList() {
  const [returnsFilter, setReturnsFilter] = useUrlFilterState(
    {
      branchFilter: "Mine",
      myBranchesFilter: "All",
      search: "",
      page: 1,
      pageSize: 25,
    },
    { exclude: ["pageSize"] },
  );

  const { isPending, isError, data, error, isFetching } =
    useReturnOrderPendingList(returnsFilter);
  const returns = data?.data.data.data.list?.orderHeader;

  return (
    <>
      <GenericListHeader heading={"Returns Pending"} />
      <ReturnTableFilterBar
        returnsFilter={returnsFilter}
        setReturnsFilter={setReturnsFilter}
      />
      {isError && <span>Error: {error.message}</span>}
      {returns && returns.length !== 0 ? (
        <ReturnTable
          data={data}
          loading={isFetching}
          returnsFilter={returnsFilter}
          setReturnsFilter={setReturnsFilter}
        />
      ) : (
        !isPending && <p>No results</p>
      )}
    </>
  );
}
